import api, { baseURL } from "../../../../utils/api";

const getV2Base = () => {
  try {
    return new URL(baseURL || "").origin;
  } catch {
    return baseURL || "";
  }
};

const V2_BASE = getV2Base();
const PATH = "/api/v2/cms/sales-panel-users";

const getAuthHeader = () => {
  const token = localStorage.getItem("ProlegionAccessToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getSalesPanelUsers = (page, limit) => {
  return api.get(`${V2_BASE}${PATH}`, {
    params: { page, limit },
    headers: getAuthHeader(),
  });
};

export const updateSalesPanelUser = (id, payload) => {
  return api.patch(`${V2_BASE}${PATH}/${id}`, payload, {
    headers: getAuthHeader(),
  });
};
